import { images } from "../../../Assets/assetsHelper";
import AddCourseForm from "../../../Components/Organisms/Forms/AddCourseForm/AddCourseForm";
import "./AddStudentsToClass.css";
import { useNavigate } from "react-router";
import {
  Card,
  CardContent,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import AddStudentsToClassForm from "../../../Components/Organisms/Forms/AddStudentsToClassForm/AddStudentsToClassForm";

function AddStudentsToClass({
  Edit = false,
  classData = null,
  loading = false,
  url,
}) {
  const navigate = useNavigate();

  return (
    <div className="mainContainer">
      <Card className="modernFormCard">
        <CardContent className="modernFormCardContent">
          <div className="formHeader">
            <div className="titleIcon">
              <MenuBookIcon />
            </div>
            <div className="titleContent">
              <h1>Add New Students</h1>
            </div>
          </div>

          <div className="formDivider"></div>

          <Box className="modernFormWrapper">
            {loading ? (
              <div className="loadingBox">
                <CircularProgress />
              </div>
            ) : (
              <AddStudentsToClassForm
                Edit={Edit}
                classData={classData}
                url={url}
              />
            )}
          </Box>
        </CardContent>
      </Card>

      {/* Modern Footer Section */}
      <div className="modernFooterSection">
        <Typography variant="body2" className="footerText">
          {Edit
            ? "Make sure all information is accurate before saving changes."
            : "Please fill in all required fields to create the program profile."}
        </Typography>
      </div>
    </div>
  );
}

export default AddStudentsToClass;
